import { ReactComponent as Partner1 } from 'assets/Home/partner/partner1Mo.svg'
import { ReactComponent as Partner2 } from 'assets/Home/partner/partner2Mo.svg'
import { ReactComponent as Partner3 } from 'assets/Home/partner/partner3Mo.svg'
import { ReactComponent as Partner4 } from 'assets/Home/partner/partner4Mo.svg'
import { ReactComponent as Partner6 } from 'assets/Home/partner/partner6Mo.svg'
import { ReactComponent as Partner7 } from 'assets/Home/partner/partner7Mo.svg'
import { ReactComponent as Partner8 } from 'assets/Home/partner/partner8Mo.svg'
import { ReactComponent as Partner9 } from 'assets/Home/partner/partner9Mo.svg'
import { ReactComponent as Partner11 } from 'assets/Home/partner/partner11Mo.svg'
import { ReactComponent as Partner12 } from 'assets/Home/partner/partner12Mo.svg'
import Marquee from "react-fast-marquee";

const Fourth = () => {
  const partner = [
    { logo: Partner1 },
    { logo: Partner2 },
    { logo: Partner3 },
    { logo: Partner4 },
    { logo: Partner6 },
    { logo: Partner7 },
    { logo: Partner8 },
    { logo: Partner9 },
    { logo: Partner11 },
    { logo: Partner12 },
  ]
  return (
    <div className="flex flex-col justify-center items-center gap-4.5 bg-black py-4.5 w-full">
      <Marquee>
        {
          partner.map((item, idx) => (
            <item.logo key={idx} className='mr-4' />
          ))
        }
      </Marquee>
      <Marquee
        direction='right'>
        {
          partner.map((item, idx) => (
            <item.logo key={idx} className='mr-4' />
          ))
        }
      </Marquee>
    </div>
  )
}

export default Fourth
